module.exports = __webpack_public_path__ + "static/media/store.fec4413a.jpg";